import { axios } from '@Root/API'

export const get = (studyProgrammeId, courseInitiativeId) => {
	return axios.get(`program/${studyProgrammeId}/course-initiative/${courseInitiativeId}`)
}
